import { render, staticRenderFns } from "./ModalRegion.vue?vue&type=template&id=2af52bec&"
import script from "./ModalRegion.vue?vue&type=script&lang=js&"
export * from "./ModalRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports